import React from 'react';
import { hot } from 'react-hot-loader';
import s from './Select.scss';

const Select = ({ variantClasses = [], id, options, selected, inputChange, disabledKey = 'disabled', inputBlur = () => {}, isError = false, label = null }) => {
	const inputChangeHandlar = (e) => {
		e.preventDefault();
		const $input = e.currentTarget;
		inputChange($input.id, $input.value);
	};

	const inputBlurHandlar = (e) => {
		e.preventDefault();
		const $input = e.currentTarget;
		inputBlur($input.id, $input.value);
	};

	const selectClasses = [s.select, s[`select__${id}`]];
	const labelClasses = [s.label];

	if (!Array.isArray(variantClasses)) variantClasses = [String(variantClasses)];
	variantClasses.filter((c) => !!c).forEach((c) => {
		if (c.indexOf('label') !== -1) labelClasses.push(s[c]);
		else selectClasses.push(s[c]);
	});

	if (isError === true) {
		selectClasses.push(s.select__error);
		labelClasses.push(s.label__error);
	}

	label = label || null;

	const select = (
		<div className={selectClasses.join(' ')}>
			<select name={id} id={id} onChange={inputChangeHandlar} onBlur={inputBlurHandlar} value={selected}>
				{
					options.map((option) => (typeof option === 'object' ? <option key={option.key} value={option.key} disabled={option[disabledKey] ? true : null}>{option.value}</option> : <option key={option} value={option}>{option}</option>))
				}
			</select><span />
		</div>
	);

	return (
		label ? (
			<label className={labelClasses.join(' ')} htmlFor={id}>
				<span className={s.label_title}>{ label }</span>
				{ select }
			</label>
		) : select
	);
};

export default hot(module)(Select);
